// Single source of truth for contact channels — easy to update later.
export const CONTACT = {
  email: "ai@intimeinc.co.in",
  phoneDisplay: "+91 90516 15690",
  whatsappNumber: "919051615690", // E.164 without "+" — used in wa.me links
};

export const waLink = (text) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(text)}`;

/**
 * Click handler that forces external links to escape a parent iframe.
 * Use on WhatsApp / external CTAs so they open in a real new tab even
 * when the page is embedded (e.g. inside a preview pane).
 */
export const openExternal = (e) => {
  try {
    if (window.top && window.top !== window.self) {
      e.preventDefault();
      window.open(e.currentTarget.href, "_blank", "noopener,noreferrer");
    }
  } catch (_) {
    // cross-origin top access blocked — fall through to default behaviour
  }
};

export const mailLink = ({ subject, body }) =>
  `mailto:${CONTACT.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
